import Card from '../../../componentsNew/Card';
import Typography from '../../../componentsNew/Typography';
import { FaArrowTrendUp } from 'react-icons/fa6';

export function CardItensSugestoes({ campo, valor }) {
  return (
    <div className="w-full border-[2px] border-solid border-[#eceef2] rounded-md">
      {/*TODO:add cor #f9fafb como variavel*/}
      <Typography
        component="base"
        className="font-normal text-[0.875em] px-4 py-2 bg-[#f9fafb] bg-opacity-50 border-solid border-[#eceef2] border-b-[2px] border-x-0 border-t-0"
      >
        Coletividade
      </Typography>
      <div className="p-4 flex gap-4">
        <div className="w-1/2">
          <Typography component="body-medium" className="mb-2">
            Keyword Difficulty
          </Typography>
          <div className="gap-4 flex">
            <Typography component="h3-semibold">9.5</Typography>
            <Card className="flex gap-1 px-1 !rounded-[5px]">
              <FaArrowTrendUp className="text-sucess-main w-3" />
              <Typography component="body-number" className="">
                7.4%
              </Typography>
            </Card>
          </div>
        </div>
        <div className="w-1/2">
          <Typography component="body-medium" className="mb-2">
            Keyword Difficulty
          </Typography>
          <div className="gap-4 flex">
            <Typography component="h3-semibold">9.5</Typography>
            <Card className="flex gap-1 px-2 !rounded-[5px]">
              <FaArrowTrendUp className="text-sucess-main w-3" />
              <Typography component="body-number">7.4%</Typography>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}
